export default __webpack_public_path__ + "static/media/add-network-resource-selected.f0341db4.svg";